import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import axiosClient from '@lib/utils/axiosClient';

const fetchClientSecret = async (url: string, clientName: string) => {
  const postPayload = {
    clientName,
  };
  const response = await axiosClient.put(url, postPayload);
  return response.data;
};
const useTriggerClientRotation = (clientName: string) => {
  const [rotationEnabled, setRotationEnabled] = useState(false);
  const [clientSecretCreated, setClientSecretCreated] = useState(false);
  const [rotationData, setRotationData] = useState({
    clientId: '',
    clientSecret: '',
  });
  const endpoint = 'v2/auth/clients';
  const { data, isError } = useQuery('clientsrotate', () => fetchClientSecret(endpoint, clientName), {
    enabled: rotationEnabled,
  });

  useEffect(() => {
    setRotationData(data);
    setRotationEnabled(false);
    if (data?.clientId && data?.clientSecret) {
      setClientSecretCreated(true);
    }
  }, [data]);

  const resetRotationData = () => {
    setRotationData({
      clientId: '',
      clientSecret: '',
    });
    setClientSecretCreated(false);
  };

  return {
    rotationEnabled,
    rotationFailed: isError,
    setRotationEnabled,
    rotationData,
    clientSecretCreated,
    setTokenCreated: setClientSecretCreated,
    resetRotationData,
  };
};

export default useTriggerClientRotation;
